import {Controller} from "stimulus";

declare global {
  interface Window {confetti: any}
}

export default class ConfettiController extends Controller {
  private static scriptLoaded = false;

  connect() {
    this.loadScript().then(() => this.fire());
  }

  private fire() {
    if (!window.confetti) return;

    const rand = (min: number, max: number) => Math.random() * (max - min) + min;

    window.confetti({
      angle: rand(45, 135),
      origin: {y: 0.6},
      particleCount: rand(50, 100),
      spread: rand(50, 70),
      zIndex: 1,
    });
  }

  private loadScript(): Promise<void> {
    if (window.confetti) return Promise.resolve();

    const src = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.4/dist/confetti.browser.min.js";
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return this.waitForConfetti();

    const script = document.createElement("script");
    script.src = src;
    script.crossOrigin = "anonymous";
    script.integrity = "sha512-YOBx/ev2NFNqeGwTFKab9vwK41aoUQO86+KN81hpiOwJbojDaKX05KJPnScTpMhXiMLA9Xf1zzXwjR8TaUnYKQ==";
    script.referrerPolicy = "no-referrer";
    document.head.appendChild(script);

    return new Promise((resolve) => {
      script.onload = () => resolve();
    });
  }

  private waitForConfetti(): Promise<void> {
    return new Promise((resolve) => {
      const check = () => (window.confetti ? resolve() : requestAnimationFrame(check));
      check();
    });
  }
}
